import { render, staticRenderFns } from "./ServerSettings.vue?vue&type=template&id=54ed4508&scoped=true"
import script from "./ServerSettings.vue?vue&type=script&lang=js"
export * from "./ServerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed4508",
  null
  
)

export default component.exports